/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_Gap_AllowedInputs */



/**
* | output |
* | --- |
* | "Minimum gap allowed between frames" |
*
* @param {Minimum_Gap_AllowedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const minimum_gap_allowed = /** @type {((inputs?: Minimum_Gap_AllowedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_Gap_AllowedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Écart minimum autorisé entre les images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestabstand zwischen den Bildern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spazio minimo consentito tra i telai")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимально допустимый зазор между рамками")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espacio mínimo permitido entre marcos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧之间允许的最小间隙")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム間の最小許容ギャップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेमों के बीच न्यूनतम अनुमत अंतराल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Espaço mínimo permitido entre quadros")
	return /** @type {LocalizedString} */ ("Minimum gap allowed between frames")
});